<svg class="progress" [attr.width]="width" [attr.height]="height" [attr.viewBox]="'0 0 ' + width + ' ' + height">
  <circle class="progress-meter" [attr.cx]="width / 2" [attr.cy]="height / 2" [attr.r]="radius"
      [attr.stroke-width]="strokeWidth"/>
  <circle class="progress-value" [style.strokeDasharray]="circumference" [style.strokeDashoffset]="strokeDashoffset"
      [attr.cx]="width/2" [attr.cy]="height / 2" [attr.r]="radius" [attr.stroke-width]="strokeWidth"/>
</svg>
